/*
 * This code was generated with assistance from GitHub Copilot.
 * De-bundled from react-dxd-components@0.1.33 compiled dist/index.js (webpack module id 10).
 */
import * as React from 'react';
import { LABEL_TYPES, LabelType } from './LABEL_TYPESConstants';

export interface LabelProps {
  /** A unique identifier */
  id: string;
  /** Text value used in aria-label or label element depending on labelType */
  label: string;
  /** Use 'aria' for an aria-label only or 'visible' for a visible <label> element */
  labelType?: LabelType;
}

const Label = ({ id, label, labelType = LABEL_TYPES.VISIBLE }: LabelProps) => {
  if (labelType === LABEL_TYPES.ARIA) {
    return null;
  }

  return (
    <label id={`labelFor-${id}`} htmlFor={id} className="Field-label">
      {label}
    </label>
  );
};

export default Label;


